import {auth} from './api';
import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword } from "firebase/auth";
import { db } from './api';
import { Timestamp, doc, getDoc, setDoc, runTransaction } from "firebase/firestore";
import sha256 from 'crypto-js/sha256';

/**
 * Crea un usuario en la base de datos y de autentica
 * @param {string} email 
 * @param {string} name
 * @param {string} password 
 * @param {string} userType
 * @returns {boolean} retorna verdadero si creo el usuario 
 */
export const createUser = async (email, name, password, userType) => {
    try {
        //crea el usuario en auth
        const user = await createUserWithEmailAndPassword(auth, email, password);
        //console.log(user);
        //crea el usuario en la base de datos
        await setDoc(doc(db, "users", user.user.uid), {
            email: email,
            name: name,
            password: sha256(password).toString(),
            phone: "",
            userType: userType,
            created: Timestamp.fromDate(new Date()),
            updated: Timestamp.fromDate(new Date())
        });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}

/**
 * Envia un correo para recuperar la contraseña
 * @param {string} email correo del usuario
 * @returns {boolean} retorna verdadero si envio el correo
 */
export const recoverPassword = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * Loguea un usuario en la base de datos
 * @param {string} email correo del usuario
 * @param {string} password contraseña del usuario
 * @returns usuario logueado
 */
export const loginUser = async (email, password) => {
    try {
        const user = await signInWithEmailAndPassword(auth, email, password);
        const userDoc = await getDoc(doc(db, "users", user.user.uid));
        let userData = userDoc.data();
        userData.uid = user.user.uid;
        return userData;
    }
    catch (error) {
        console.error(error);
        return null;
    }
}


/**
 * Cierra la sesion del usuario
 * @returns boolean retorna verdadero si cerro la sesion
 */
export const logoutUser = async () => {
    try {
        await auth.signOut();
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
};

/**
 * Actualiza el nombre del usuario en la base de datos 
 * en users, comments y forum
 * @param {string} userId id del usuario
 * @param {string} newName nuevo nombre del usuario
 * @returns {boolean} retorna verdadero si actualizo el nombre
 */
export const updateUserNames = async (userId, newName) => {
    try {
      await runTransaction(db, async (transaction) => {
        // Actualizar el nombre en la colección de usuarios
        const userRef = doc(db, "users", userId);
        transaction.update(userRef, { name: newName });
  
        // Actualizar el nombre en la colección de comentarios
        const comentarios = db.collection("comments");
        const q = db.collection("comments").where("autorId", "==", userId);
        const querySnapshot = await transaction.get(q);
        querySnapshot.forEach((doc) => {
          transaction.update(doc.ref, { autor: newName });
        });

        // Actualizar el nombre en la colección de foros
        const foros = db.collection("forum");
        const q2 = db.collection("forum").where("autorId", "==", userId);
        const querySnapshot2 = await transaction.get(q2);
        querySnapshot2.forEach((doc) => {
          transaction.update(doc.ref, { autor: newName });
        });
      });
  
      return true;
    } catch (error) {
      console.error("Transaction failed: ", error);
      return false;
    }
};


/**
 * Agregar una foto de perfil al usuario
 * @param {string} userId id del usuario
 * @param {string} url url de la foto
 * @returns {boolean} retorna verdadero si actualizo la foto
 */
export const updateProfilePhoto = async (userId, url) => {
    try {
        const userRef = doc(db, "users", userId);
        await setDoc(userRef, { photo: url }, { merge: true });
        return true;
    } catch (error) {
        console.error(error);
        return false;
    }
}


/**
 * Función para obtener la información de un usuario
 * @param {string} userId id del usuario
 * @returns {object} retorna la información del usuario
 */
export const getUser = async (userId) => {
    try {
        const userDoc = await getDoc(doc(db, "users", userId));
        let userData = userDoc.data();
        userData.uid = userId;
        return userData;
    } catch (error) {
        console.error(error);
        return null;
    }
}